module.exports = "/_next/static/images/4d5aa64c9436116e635c1dba0a6f042b-mgm-lg-2x.jpg";